import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_2 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "form-check-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass({ required: _ctx.input.required })
          }, _toDisplayString(_ctx.input.label), 3)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (opt) => {
          return (_openBlock(), _createElementBlock("div", {
            key: opt.id,
            class: "d-flex form-check form-check-custom form-check-solid mb-2"
          }, [
            _createElementVNode("span", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "form-check-input",
                name: _ctx.input.name + '[]',
                value: opt.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event))
              }, null, 8, _hoisted_3), [
                [_vModelCheckbox, _ctx.model]
              ]),
              _createElementVNode("span", _hoisted_4, _toDisplayString(opt.description), 1)
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}